import { HORIZON_NEXT_PHASE, nextPhaseAfterOffer } from "@/config/lifecycle";
import { withCurrentSearch } from "@/utils/searchParams";

interface NextPhaseHandoffProps {
  offerId?: string;
  variant?: "offer" | "horizon";
}

/** One-line next phase after a preview or purchase. Not a second primary CTA. */
export function NextPhaseHandoff({ offerId, variant = "offer" }: NextPhaseHandoffProps) {
  const next = variant === "horizon" ? HORIZON_NEXT_PHASE : nextPhaseAfterOffer(offerId ?? "");

  return (
    <p className="mt-6 text-base text-ink-soft">
      <a className="font-semibold text-brand-700 underline underline-offset-2 hover:text-brand-900" href={withCurrentSearch(next.href)}>
        {next.linkText}
      </a>
      . {next.suffix}.
    </p>
  );
}
